'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const navLinks = [
  { label: 'Marketplace', href: '/marketplace' },
  { label: 'Community', href: '/community-feed' },
  { label: 'Pet Academy', href: '#academy' },
  { label: 'NFC Tags', href: '#nfc' },
  { label: 'Directory', href: '#directory' },
];

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-white/90 backdrop-blur-md shadow-card'
            : 'bg-white/70 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2 no-underline">
            <img
              src="/assets/images/logo-full-1785153841359.png"
              alt="PetHub PH Logo"
              className="h-9 w-auto object-contain"
            />
          </Link>

          {/* Desktop nav */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks?.map((link) => (
              <Link
                key={`nav-${link?.label}`}
                href={link?.href}
                className="btn-ghost text-sm font-semibold text-body-text hover:text-foreground no-underline"
              >
                {link?.label}
              </Link>
            ))}
          </div>

          {/* Auth buttons */}
          <div className="hidden lg:flex items-center gap-3">
            <Link href="/sign-up-login-screen" className="btn-ghost text-sm no-underline">
              Log in
            </Link>
            <Link href="/sign-up-login-screen" className="btn-primary text-sm no-underline">
              Join Free
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-chip-bg transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <Icon name={mobileOpen ? 'XMarkIcon' : 'Bars3Icon'} size={22} />
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="lg:hidden bg-white border-t border-border px-6 py-4 flex flex-col gap-2 fade-in">
            {navLinks?.map((link) => (
              <Link
                key={`mobile-nav-${link?.label}`}
                href={link?.href}
                className="py-2 text-sm font-semibold text-body-text hover:text-primary no-underline"
                onClick={() => setMobileOpen(false)}
              >
                {link?.label}
              </Link>
            ))}
            <div className="flex gap-3 mt-3 pt-3 border-t border-border">
              <Link href="/sign-up-login-screen" className="btn-outline text-sm no-underline flex-1 justify-center">
                Log in
              </Link>
              <Link href="/sign-up-login-screen" className="btn-primary text-sm no-underline flex-1 justify-center">
                Join Free
              </Link>
            </div>
          </div>
        )}
      </nav>
    </>
  );
}